<template>
    <div class="lm-loader">
        <div v-if="!loading">
            <slot></slot>
        </div>
        <div v-else>
            <img class="background-loader" :src="backgroundUrl" alt="Loader">
        </div>
    </div>
</template>

<script>
    export default {
        name: "CityMapLoader",
        data() {
            return {
                loading: true,
                img: '',
            }
        },
        created() {
            if (this.$root.env === 'renderer'){
                this.loading = false;
            }
            let {mobile,dekstop} = this.$root?.lovemap?.citymap?.loader;

            if (window.matchMedia("(max-width: 768px)").matches) {
                this.img = mobile;
            } else {
                this.img = dekstop;
            }
        },
        mounted() {
            let vm = this;
            if (this.$root.env !== 'frontend'){
                this.loading = false;
            }else{
                jQuery(window).load(function () {
                    vm.loading = false
                });
            }
        },
        computed:{
            backgroundUrl(){
                return this.$canUseWebP() ? this.img : this.img.replace('.webp','.png')
            },
        }
    }
</script>

<style lang="scss" scoped>
    .lm-loader{
        .background-loader{
            filter: blur(3px);
            width: 100%;
            height: auto;
        }
    }
</style>